export default {
  title: 'Encuentre ilustraciones, iconos y dibujos científicos',
  subTitle:
    '¡De la mayor galería del mundo de ilustraciones, imágenes, fotografías e iconos científicamente precisos!',
  label: 'Busque entre nuestras más de 75.000 ilustraciones',
};
